import * as React from "react"
import {Box, Grid, Typography} from "@mui/material";
import {ModalSeeker} from "@ui-seeker/core"
import {formatAbbreviateNumber, formatDate, formatNumber} from "@ui-seeker/utils";

import {HierarchicalTextBlock, RatingStars} from "@components";
import ProductPagesModalSkuBlock from "../SkuBlock";


export default function ProductPagesDetailsModalRating({ isOpen, controller, rating, reviews, data }) {
    const lastReviewRating = data.lastReviewRating
    
    return <ModalSeeker
        isOpen={isOpen}
        controller={controller}
        size="md"
        hideActions
        title='Product Rating & Reviews details'
    >
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <ProductPagesModalSkuBlock
                    date={data.date}
                    company={data.company}
                    category={data.category}
                    productID={data.productID}
                    siteID={data.siteID}
                    sku={data.skuName}
                    brand={data.brand}
                    country={data.country}
                    retailer={data.retailer}
                    siteURL={data.siteURL}
                    ean={data.ean}
                    supertitle={data.supertitle}
					productTitle={data.productTitle}
					subtitle={data.subtitle}
					brandRaw={data.brand}
                />
            </Grid>
        </Grid>
        <Grid item xs={12}>
            <Box sx={{ display: 'flex', width: '100%', m: '30px 0', flexDirection: 'row', alignItems: 'flex-start' }}>
                <Box sx={{ width: '20%', textAlign: 'center'}}>
                    <Typography sx={{ fontWeight: 'bold', fontSize: "3rem", fontStyle: 'italic' }}>
                        { formatNumber(rating, { decimals: 1 }) }
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <RatingStars rating={rating} />
                    </Box>
                </Box>
                <Box sx={{ width: '80%', display: 'inline-block'}}>
                    { !!reviews && <Box sx={{ mt: 1 }}>
                        <b>Reviews: </b> {formatAbbreviateNumber(reviews)}
                    </Box> }
                </Box>
                {!!lastReviewRating && <Grid item xs={12}>
                    <Box sx={{mb: 4}}>
                        <Typography fontWeight='bold' fontSize={18} mb={.5}>Last Review</Typography>
                        <Box sx={{ pl: 2.5 }}>
                            <HierarchicalTextBlock
                                supertitle="Date:"
                                supertitleValue={lastReviewRating && formatDate(data.lastReview, { isString: true })}
                                title="Rating:"
                                titleValue={lastReviewRating}
                                subtitle="Title:"
                                subtitleValue={data.lastReviewTitle}
                            />
                            <HierarchicalTextBlock
                                supertitle="Text:"
                                supertitleValue={data.lastReviewText}
                            />
                        </Box>
                    </Box>
                </Grid>}
            </Box>
        </Grid>
    </ModalSeeker>
}